

export const dashboardHome = {
  namespaced: true,
  state: {
    messageSearch: null,
    toggleAccess: null
  },
  mutations: {
    storeMessageSearch(state, search) {
      state.messageSearch = search;     
    },
    storeToggleAccess(state, value) {
      state.toggleAccess = value;
    }
  }
}
